import { FaqEntry } from "../../types/support";
import { ResponseResType } from "../../types/common/response";
import { baseApi } from "../../util/axiosConfig";
import { DeleteFaqApiProps, ReadFaqApiProps, ReadFaqDetailApiProps, UpdateFaqApiProps } from "../../types/support/faq";


const url = "api/customer/support/faq/";

/**
 * FAQ 목록 불러오기
 * @returns
 */
export async function readFaqApi(data: ReadFaqApiProps): Promise<
  ResponseResType<{ faqList: FaqEntry[], totalCount: number }>
> {
  const response = await baseApi.post(url + "read_faq", data);

  return response?.data;
}

/**
 * FAQ 선택 삭제
 * @returns
 */
export async function deleteFaqApi(data: DeleteFaqApiProps): Promise<
  ResponseResType<any>
> {
  const response = await baseApi.post(url + "delete_faq", data);

  return response?.data;
}

/**
 * FAQ 상세조회
 * @returns
 */
export async function readFaqDetailApi(faqId: string | null): Promise<
  ResponseResType<{ faqDetailRes: ReadFaqDetailApiProps }>
> {
  const response = await baseApi.post(url + "read_faq_detail", { faqId });

  return response?.data;
}

/**
 * FAQ 수정
 * @returns
 */
export async function updateFaqApi(data: UpdateFaqApiProps): Promise<
  ResponseResType<{ faqDetailRes: ReadFaqDetailApiProps }>
> {
  const formData = new FormData();
  formData.append("faqId", data.faqId);
  formData.append("title", data.title);
  formData.append("topicTypeIdx", data.topicTypeIdx.toString());
  if (data.newProductGroupid)
    formData.append("newProductGroupid", data.newProductGroupid);
  formData.append("isNotice", data.isNotice);
  formData.append("body", data.body);
  console.log(data);
  (data.fileKeyList ?? []).forEach((item) => {
    formData.append("fileKeyList", item);
  });
  (data.fileList ?? []).forEach((item) => {
    formData.append("FileList", item.file);
  });

  const response = await baseApi.post(url + "update_faq", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response?.data;
}

/**
 * FAQ 저장
 * @returns
 */
export async function createFaqApi(data: UpdateFaqApiProps): Promise<
  ResponseResType<ReadFaqDetailApiProps>
> {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("topicTypeIdx", data.topicTypeIdx.toString());
  formData.append("newProductGroupid", data.newProductGroupid);
  formData.append("isNotice", data.isNotice);
  formData.append("body", data.body);
  (data.fileList ?? []).forEach((item) => {
    formData.append("fileList", item.file);
  });

  const response = await baseApi.post(url + "create_faq", formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response?.data;
}

/**
 * FAQ 해더 조회
 * @returns
 */
export async function getCustomerSupportFaqReadFaqHeaderapi(): Promise<
  ResponseResType<any>
> {
  const response = await baseApi.get(url + "read_faq_header");
  return response?.data;
}

/**
 * 타입에 따른 faq List 조회
 * @returns
 */
export async function getCustomerSupportFaqReadFaqListapi(topicTypeName: string): Promise<
  ResponseResType<any>
> {
  const response = await baseApi.get(url + "read_faq_list_by_topic_type_name", { params: { topicTypeName } });
  return response?.data;
}

/**
 * FAQ 해더 저장
 * @returns
 */
export async function postCustomerSupportFaqSaveFaqHeaderapi(data: any): Promise<
  ResponseResType<any>
> {
  const response = await baseApi.post(url + "save_faq_header", data);

  return response?.data;
}